class NavMenu {
  constructor() {
    this.mobileNavQuery = window.matchMedia("(max-width: 1200px)")
    this.mobileNavQuery.addEventListener("change", this.handleMediaChange)

    this.subMenuArrows()
    this.menuInit()
  }

  menuInit = () => {
    if (this.mobileNavQuery.matches) {
      this.removeDesktopEvents()
      this.primaryNavMenuMobile()
    } else {
      this.removeMobileEvents()
      this.primaryNavMenuDesktop()
      this.fixTopMenu()
    }
  }

  handleMediaChange = (e) => {
    if (e.matches) {
      this.removeDesktopEvents()
      this.primaryNavMenuMobile()
    } else {
      this.removeDesktopEvents()
      this.removeMobileEvents()
      this.primaryNavMenuDesktop()
    }
  }

  removeMobileEvents = () => {
    const navtoggle = document.querySelectorAll('.navtoggle'),
      menu_item_has_children_link = document.querySelectorAll('.menu-item-has-children > a .icon-menu-arrow'),
      menu_container = document.getElementById('primary-menu-container'),
      menu_item_has_children = document.querySelectorAll('.menu-item-has-children'),
      icon_sub_menu_arrow = document.querySelectorAll('.icon-sub-menu-arrow')

    menu_container.style.removeProperty('display')
    menu_container.style.removeProperty('box-sizing')

    menu_item_has_children.forEach((item) => {
      const sub_menu = item.querySelector('.sub-menu')

      sub_menu.style.removeProperty('display')
      sub_menu.style.removeProperty('box-sizing')
    })

    navtoggle.forEach((item) => {
      item.classList.remove('navtoggle--active')

      item.removeEventListener('click', this.onClickToggleMenu)
    })

    menu_item_has_children_link.forEach((item) => {
      item.removeEventListener('click', this.onClickToggleSubmenu)
    })

    icon_sub_menu_arrow.forEach((item) => {
      item.classList.remove('active')
    })
  }

  removeDesktopEvents = () => {
    const menu_item_has_children = document.querySelectorAll('.menu-item-has-children')

    menu_item_has_children.forEach((item) => {
      if (!item.dataset.desktopBound) {
        return
      }

      const link = item.querySelector('a')

      if (item._desktopEnter) {
        item.removeEventListener('mouseenter', item._desktopEnter)
      }

      if (item._desktopLeave) {
        item.removeEventListener('mouseleave', item._desktopLeave)
      }

      link.classList.remove('active')
      delete item._desktopEnter
      delete item._desktopLeave
      delete item.dataset.desktopBound
    })
  }

  primaryNavMenuMobile = () => {
    this.removeMobileEvents()

    const navtoggle = document.querySelectorAll('.navtoggle'),
      menu_item_has_children_link = document.querySelectorAll('.menu-item-has-children > a .icon-menu-arrow')

    navtoggle.forEach((item) => {
      item.addEventListener('click', this.onClickToggleMenu)
    })

    menu_item_has_children_link.forEach((item) => {
      item.addEventListener('click', this.onClickToggleSubmenu)
    })
  }

  primaryNavMenuDesktop = () => {
    const menu_item_has_children = document.querySelectorAll('.menu-item-has-children')

    menu_item_has_children.forEach((item) => {
      if (item.dataset.desktopBound) {
        return
      }

      let link = item.querySelector('a')
      const onMouseEnter = () => {
        link.classList.add('active')
      }
      const onMouseLeave = () => {
        link.classList.remove('active')
      }

      item.addEventListener('mouseenter', onMouseEnter)
      item.addEventListener('mouseleave', onMouseLeave)

      item._desktopEnter = onMouseEnter
      item._desktopLeave = onMouseLeave
      item.dataset.desktopBound = 'true'
    })
  }

  onClickToggleMenu = (e) => {
    const { slideToggle } = this

    e.preventDefault()
    let old_timestamp = null
    // Prevent double click before animation ends
    if (old_timestamp == null || old_timestamp + (300 + 1) < e.timeStamp) {
      const menu_container = document.getElementById('primary-menu-container')
      e.target.classList.toggle('navtoggle--active')
      slideToggle(menu_container, 300)
      old_timestamp = e.timeStamp;
    }
    old_timestamp = null
  }

  onClickToggleSubmenu = (e) => {
    const { slideToggle } = this

    e.preventDefault()
    let old_timestamp = null
    // Prevent double click before animation ends
    if (old_timestamp == null || old_timestamp + (300 + 1) < e.timeStamp) {
      e.target.parentElement.classList.toggle('active')
      slideToggle(e.target.parentElement.nextElementSibling, 300)
      old_timestamp = e.timeStamp;
    }
    old_timestamp = null
  }

  subMenuArrows = () => {
    const icon_sub_menu_arrow = document.querySelectorAll('.icon-sub-menu-arrow')

    icon_sub_menu_arrow.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        e.preventDefault()
        item.classList.toggle('active')

        this.slideToggle(item.parentElement.nextElementSibling, 400)
      })
    })
  }

  fixTopMenu = () => {
    const hide_nav_menu = document.querySelector('.hide-nav-menu')
    if (hide_nav_menu && hide_nav_menu.classList.contains('hide-nav-menu')) {
      return
    }
    const nav_menu = document.getElementById('masthead')
    // const body_classes = document.body.classList
    let class_names_to_add = "fixed-top bg-secondary shadow scroll-active"
    const nav_menu_style_class = nav_menu.dataset.nav_menu_style

    // if (document.body.classList.contains('page-template-template-landing')) {
    //   class_names_to_add = "fixed-top bg-secondary shadow scroll-active"
    // }

    // if (body_classes.contains('menu-style-2')) {
    //   if (document.documentElement.scrollTop > 20) {
    //     document.body.classList.remove('bg-secondary')
    //   }
    // }

    if (document.documentElement.scrollTop > 88) {
      nav_menu.className = class_names_to_add
    }

    window.addEventListener('scroll', () => {
      if (window.innerWidth > 1200) {
        if (document.documentElement.scrollTop > 88) {
          nav_menu.className = class_names_to_add
          // if (body_classes.contains('menu-style-2')) {
          //   document.body.classList.remove('bg-secondary')
          // }
        } else {
          nav_menu.className = "site-header position-fixed top-0 " + nav_menu_style_class
          // if (body_classes.contains('menu-style-2')) {
          //   document.body.classList.add('bg-secondary')
          // }
        }
      }
    })
  }

  slideUp = (target, duration = 300) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  slideDown = (target, duration = 300) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
      display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  slideToggle = (target, duration = 300) => {
    const { slideDown, slideUp } = this

    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
  }
}

export default NavMenu
